import { useState } from "react";
import { doForgotPassword } from "@/services/service-layer/authService";
import OpticksInput from "@/components/ui/OpticksInput/OpticksInput";
import OpticksLink from "@/components/ui/OpticksLink/OpticksLink";
import OpticksButton from "@/components/ui/OpticksButton/OpticksButton";
import { useForm, Controller } from "react-hook-form";
import type { ForgotPasswordFormPayload } from "@/types/model/Auth";
import OpticksLogo from "@/components/ui/OpticksLogos/OpticksLogo";

const ForgotPassword = () => {
  const [isPasswordRestored, setIsPasswordRestored] = useState(false);

  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = useForm<ForgotPasswordFormPayload>({
    mode: "onSubmit",
    defaultValues: {
      email: "",
    },
  });

  const handleForgotPassword = (values: ForgotPasswordFormPayload) => {
    setIsPasswordRestored(true);
    doForgotPassword(values);
  };

  if (isPasswordRestored) {
    return (
      <>
        <OpticksLogo />
        <h2>Email Sent</h2>
        <p>
          We have just sent you an email with a link to reset your password.
        </p>
      </>
    );
  }
  return (
    <>
      <OpticksLogo />
      <h2>Forgot your password?</h2>

      <form
        className="auth-form"
        noValidate
        onSubmit={handleSubmit(handleForgotPassword)}
      >
        <p>Enter your email and we will send you a link to restore it.</p>

        <div className="fields">
          <Controller
            name="email"
            control={control}
            rules={{
              required: "Email is required",
              validate: (value) =>
                /\S+@\S+\.\S+/.test(value) || "A valid email is required",
            }}
            render={({ field }) => (
              <div>
                <OpticksInput
                  placeholder="Email"
                  type="email"
                  required
                  surface="white"
                  input={field}
                />
                {errors.email && (
                  <span className="form-invalid-message">
                    {errors.email.message}
                  </span>
                )}
              </div>
            )}
          />
        </div>

        <div className="login-btn">
          <OpticksButton
            type="submit"
            size="m-wide"
            disabled={isSubmitting}
            label="Restore password"
          />
        </div>

        <div className="create-account">
          <span>
            Have any questions?{" "}
            <OpticksLink
              href="https://optickssecurity.com/contact-us"
              label="Contact Us"
            />
          </span>
        </div>
      </form>
    </>
  );
};

export default ForgotPassword;
